export const MAX_POLLING_RETRIES = 3;
export const POLLING_DELAY = 5000;
